
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyCardinalSouth as ObiSimplifiedBuoyCardinalSouthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-cardinal-south.js';
 
 
 

 
 export const ObiSimplifiedBuoyCardinalSouth = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-cardinal-south',
   elementClass: ObiSimplifiedBuoyCardinalSouthElement,
   events: {
     
   }
  });
 
 